import { Directive, ElementRef, Renderer2, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[privacySensitive]'
})
export class PrivacySensitiveDirective implements OnInit {
  @Input()
  privacySensitive: boolean;

  constructor(private _hostElement: ElementRef, private _renderer: Renderer2) {}

  ngOnInit(): void {
    const { privacySensitive } = this;
    if (!privacySensitive) return;

    this._renderer.addClass(
      this._hostElement.nativeElement,
      'usabilla-dont-show'
    );
    this._renderer.setAttribute(
      this._hostElement.nativeElement,
      'data-hj-suppress',
      ''
    );
  }
}
